<template>
  <v-card flat>
    <!-- بخش تصاویر (لوگو و پس زمینه) -->
    <div v-for="(item, i) in computedImages" :key="i">
      <v-card-title class="pb-2" v-text="item.name || (i===0 ? $t('image_logo') : i===1 ? $t('background_image') : '')" />
      <pic-selector
        :edit-name="false"
        :field.sync="item[item.value]"
        default-cat-name="تصاویر فروشگاه"
        one-pic
        single
      />
    </div>

    <!-- سوئیچ فعال‌سازی خوش‌آمدگویی -->
    <!-- <v-col class="pa-2" cols="12">
      <v-switch
        v-model="hasWelcome"
        class="mt-0 mb-2"
        hide-details
        :label="$t('default_welcome') || 'صفحه خوش‌آمدگویی'"
      />
    </v-col> -->
                  
    <!-- بخش تنظیمات خوش‌آمدگویی (Previewer QR) -->
    <!-- <template v-if="hasWelcome">
      <v-divider class="my-4"></v-divider>
      <previewer-qr
        v-model="previewerData"
        style="width: 100%"
      />
    </template> -->
  </v-card>
</template>

<script>
import picSelector from "@/view/components/UploadCenter/picSelector.vue";
import previewerQr from "../../../qrland/components/previewerQr.vue";

export default {
  name: "shopLogo_menu",

  components: {
    picSelector, 
    previewerQr
  },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    computedImages() {
      return (this.value || []).filter(item => !item.isPreviewer);
    },

    hasWelcome: {
      get() {
        const item = (this.value || []).find(item => item.isPreviewer);
        return item ? !!item.is_active : false;
      },
      set(val) {
        let newValue = [...(this.value || [])];
        let index = newValue.findIndex(item => item.isPreviewer);
        if (index !== -1) {
          this.$set(newValue[index], 'is_active', val);
        } else {
          newValue.push({
            isPreviewer: true,
            is_active: val,
            data: {
              welcome: null,
              hasGif: true, 
              hasGame: true,
              previewerQr: {
                previewer: { gif: null, game: null },
                transition: "scale",
                gifBorderRadius: 0
              }
            }
          });
        }
        this.$emit("input", newValue);
      }
    },

    previewerData: {
      get() {
        let previewerItem = (this.value || []).find(item => item.isPreviewer);
        if (!previewerItem) {
          previewerItem = {
            isPreviewer: true,
            is_active: true,
            data: {
              welcome: null,
              hasGif: true, 
              hasGame: true,
              previewerQr: {
                previewer: { gif: null, game: null },
                transition: "scale",
                gifBorderRadius: 0
              }
            }
          };
          let newValue = [...(this.value || []), previewerItem];
          this.$emit("input", newValue);
        }
        return previewerItem.data;
      },
      set(val) {
        let index = (this.value || []).findIndex(item => item.isPreviewer);
        let newValue = [...(this.value || [])];
        if (index !== -1) {
          newValue[index].data = val;
        } else {
          newValue.push({ isPreviewer: true, is_active: true, data: val });
        }
        this.$emit("input", newValue);
      }
    }
  }
};
</script>
